/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const LicenseeSecretMode = Object.freeze({
  // @deprecated
  DISABLED: 'DISABLED',
  PREDEFINED: 'PREDEFINED',
  CLIENT: 'CLIENT',
});

export default LicenseeSecretMode;
